<template>
    <div>
        <card-header title="User Details" :subheader="user.first_name + ' ' + user.last_name" icon="fa-id-card"></card-header>

        <card-toolbar v-if="currentUser.isSuper">
            <button @click="$openCard('user-edit', {userId: user.id}, card)"><i class="far fa-pencil"></i>Edit User</button>
            <button class="icon-only"><i class="far fa-sign-in"></i></button>

            <template v-slot:right>
                <button class="icon-only btn-warning" v-b-tooltip.hover title="Delete"><i class="far fa-trash-alt"></i></button>
                <button class="icon-only"><i class="far fa-bars"></i></button>
            </template>
        </card-toolbar>

        <card-body subheader toolbar>
            <card-list>
                <navigation-list-item v-if="currentUser.isSuper" title="Notes" icon="fa-clipboard" badge="4" @action="openCard('user-notes', {userId: user.id})" :active="isActive('user-notes')"/>
                <subheader-list-item title="Personal" icon="fa-id-card"/>
            </card-list>

            <data-row title="Full Name">
                <span class="is-clickable" @click="$copyText(user.first_name + ' ' + user.last_name)">{{user.first_name}} {{user.last_name}}</span>
            </data-row>
            <data-row title="Maiden Name"><span class="is-clickable" @click="$copyText(user.maiden_name)">{{user.maiden_name}}</span></data-row>
            <data-row title="E-Mail Address"><span class="is-clickable" @click="$copyText(user.email)">{{user.email}}</span></data-row>
            <data-row title="Alt E-Mail"><span class="is-clickable" @click="$copyText(user.email_alt)">{{user.email_alt}}</span></data-row>
            <data-row title="Home Phone"><span class="is-clickable" @click="$copyText(user.phone)">{{user.phone | tel}}</span></data-row>
            <data-row title="Work Phone"><span class="is-clickable" @click="$copyText(user.phone_2)">{{user.phone_2 | tel}}</span></data-row>
            <data-row title="Address">
                <div class="is-clickable" @click="$copyText(user.address + ((user.address_2)?', '+user.address_2:', ') + user.city + ', ' + user.state + ' ' + user.zip)">
                    <div>{{user.address}}</div>
                    <div v-if="user.address_2">{{user.address_2}}</div>
                    <div>{{user.city}}, {{user.state}} &nbsp;{{user.zip}}</div>
                </div>
            </data-row>
            <data-row v-if="currentUser.isSuper" title="Date of Birth">{{user.dob_on | moment('MMMM Do, YYYY')}}<br>{{user.dob_on | moment('from', 'now', true)}} old</data-row>

            <card-list>
                <subheader-list-item title="Educator" icon="fa-chalkboard-teacher"/>
            </card-list>

            <data-row title="Grade Level">{{user.grade_level}}</data-row>
            <data-row title="Subject">{{user.subject_area}}</data-row>
            <data-row title="School">{{user.school}}</data-row>
            <data-row title="District">{{user.district}}</data-row>

<!--            <card-list>-->
<!--                <subheader-list-item title="Payment" icon="fa-credit-card"/>-->
<!--            </card-list>-->

<!--            <data-row title="On File"></data-row>-->

            <card-list>
                <subheader-list-item title="Other" icon="fa-info-circle"/>
            </card-list>

            <data-row v-if="currentUser.isSuper" title="Referral">{{user.referral}}</data-row>
            <data-row v-if="currentUser.isSuper" title="Assigned Reseller"></data-row>
            <data-row title="Registration Date">{{user.created_at | moment('MMM Do, YYYY h:mm A')}}</data-row>
            <data-row title="Last Login Date">{{user.last_login_at | moment('MMM Do, YYYY h:mm A')}}</data-row>
            <data-row title="User ID"><span class="is-clickable" @click="$copyText(user.id)">{{user.id}}</span></data-row>


            <card-list>
                <subheader-list-item title="Notes" icon="fa-align-left"/>

                <container-list-item padded v-html="(user.notes) ? user.notes.replace(/\n/g, '<br>') : 'No Notes'">
                </container-list-item>
            </card-list>

        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardContainer from "@/TIER/components/CardContainer";
    import CardSubheader from "@/TIER/components/CardSubheader";
    import DataRow from "@/TIER/components/DataRow";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";

    import {client as http} from '@/http_client';
    import { mapGetters } from "vuex";
    import ContainerListItem from "../../TIER/components/ContainerListItem.vue";

    export default {
        components: {ContainerListItem, SubheaderListItem, CardList, NavigationListItem, DataRow, CardSubheader, CardContainer, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                user: {counts: {}}
            };
        },
        computed: {
            ...mapGetters(['currentUser']),
        },
        methods: {
            loadUser: function (force) {
                this.$emit('loading', true);
                http.get('users/' + this.props.userId, {force}).then(response => {
                    this.user = response.data;
                    this.$emit('loading', false);
                });
            },
            isActive: function (component) {
                return (this.child && this.child.definition && this.child.definition.component === component);
            },
            openCard: function (card, props) {
                this.$emit('open', {card: card, props: props});
            },
            reload: function() {
                this.loadUser(true);
            }
        },
        watch: {
            'props': function (n, o) {
                if (n.userId !== o.userId) this.loadUser();
            }
        },
        mounted: function () {
            console.log('mounted')
            console.log(this.currentUser)
            this.loadUser();
        }
    };
</script>
